(function () {
  if (window.__AMWishlistIconSyncInitialized__) return;
  window.__AMWishlistIconSyncInitialized__ = true;

  function isWishlistActive(engine) {
    if (!(engine instanceof HTMLElement)) return false;
    if (engine.getAttribute('data-added') === 'true') return true;
    const button = engine.querySelector('.wishlist-engine-button');
    return button instanceof HTMLElement && button.getAttribute('data-added') === 'true';
  }

  function syncEngine(engine) {
    if (!(engine instanceof HTMLElement)) return;
    if (isWishlistActive(engine)) {
      engine.setAttribute('data-am-wishlist-active', 'true');
    } else {
      engine.removeAttribute('data-am-wishlist-active');
    }
  }

  function syncAll(root = document) {
    root.querySelectorAll('.wishlist-engine').forEach(syncEngine);
  }

  function observeEngine(engine) {
    if (!(engine instanceof HTMLElement) || engine.dataset.amWishlistObserved === 'true') return;
    engine.dataset.amWishlistObserved = 'true';
    syncEngine(engine);
    const observer = new MutationObserver(function () {
      syncEngine(engine);
    });
    observer.observe(engine, {
      attributes: true,
      attributeFilter: ['data-added', 'class'],
      subtree: true,
    });
  }

  function observeRoot(root = document) {
    root.querySelectorAll('.wishlist-engine').forEach(observeEngine);
  }

  function scheduleSync() {
    requestAnimationFrame(function () {
      observeRoot();
      syncAll();
    });
  }

  function init() {
    observeRoot();
    syncAll();

    document.addEventListener('cart:update', scheduleSync);
    document.addEventListener('am:wishlist:changed', scheduleSync);
    document.addEventListener('dialog:open', scheduleSync);

    const rootObserver = new MutationObserver(function (mutations) {
      let shouldSync = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (node.classList.contains('wishlist-engine') || node.querySelector('.wishlist-engine')) {
            shouldSync = true;
            break;
          }
        }
        if (shouldSync) break;
      }
      if (shouldSync) scheduleSync();
    });

    rootObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
